import { ClubSelectionVue } from '@/fairplayer/primary/homepage/club-selection';
import { PageVue } from '@/fairplayer/primary/page';

export default {
  name: 'Homepage',

  components: { ClubSelectionVue, PageVue },
};
